module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3026695dbf8187b9bebcfcc8ecfbe0a5.png";